import { render, staticRenderFns } from "./WorkspaceSetting.vue?vue&type=template&id=48e1f5da"
import script from "./WorkspaceSetting.vue?vue&type=script&lang=js"
export * from "./WorkspaceSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports